import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role requirement
  if (requiredRole) {
    if (requiredRole === 'host' && user.role !== 'host' && user.role !== 'admin') {
      return <Navigate to="/app" replace />;
    }
    if (requiredRole === 'admin' && user.role !== 'admin') {
      return <Navigate to="/app" replace />;
    }
  }

  return children;
}
